const store = window.store;

/**
 * @param {Array} permissionRoles
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export default function checkPermission(permissionRoles) {
  if (Array.isArray(permissionRoles) && permissionRoles.length > 0) {
    const userRole = store.getters["operators/operator"].rol;
    return permissionRoles.includes(userRole.name.toLowerCase());
  } else {
    console.warn("user has no roles");
    return false;
  }
}
